import React, { useContext } from 'react';
import { useRef, useEffect } from 'react';
import DivRow from '../../components/controls/DivRow';
import Input from '../../components/controls/Input';
import { Helmet } from 'react-helmet'
import { cotizacion } from '../../data/data';
import { useState } from 'react';
import { tipoDocumentos } from '../../data/mochaData';
import DropDownInput from '../../components/controls/DropDownInput';
import Modal from 'react-modal';
import { cedulaMask, cedulaPattern, customStyles, endPoints } from '../../utils/constanst';
import http, { setConfig } from '../../services/http';
import Container from '../../components/Container';
import { CotizadorHNDataContext } from '../../context/CotizadorHNDataContext';


const MicroSitioAutoHN = ({ location, history, ...rest }) => {

    const letterPattern = "[A-Za-z ]+";
    const dataDefault = { tipoId: '1', identificacion: '', nombre: '', apellido: '', email: '', celular: '', showModal: false, showAcceptModel: false, sendDisabled: false };

    const [data, setData] = useState({ ...dataDefault, sendDisabled: false, cedMask: '9999-9999-99999', cedPattern: cedulaPattern, tipoId: "1" });
    const { poliza, setPoliza, polizaChangeHandler } = useContext(CotizadorHNDataContext);


    useEffect(() => {
        //setConfig();
        setTimeout(() => {
            const preloader = document.querySelector('.site-preloader');

            if (preloader) {
                preloader.addEventListener('transitionend', (event) => {
                    if (event.propertyName === 'opacity') {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add('site-preloader__fade');
            }
        }, 600);

    }, [0]);


    const handleChange = (e) => setData({ ...data, [e.target.name]: e.target.value });
    const changeHandler = event => {

        let d = { ...data, [event.target.name]: event.target.value };

        if (event.target.name == "tipoId") {

            if (event.target.value == 1) {
                d.cedMask = cedulaMask;
                d.cedPattern = cedulaPattern;
            }
            else {
                d.cedMask = null;
                d.cedPattern = null;
            }
        }

        setData(d);

        setPoliza({
            asegurado: {
                tipoId: d.tipoId,
                numId: d.identificacion,
                nombre: d.nombre,
                apellido: d.apellido,
                email: d.email,
                celular: d.celular
            }
        });
    }
    const sendNotification = () => {
        let result = document.querySelector('form').reportValidity();

        if (!result) return;

        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source');
        data.nombres = data.nombre + ' ' + data.apellido;
        data["source"] = src;

        http(endPoints.notificationAuto).post({ ...data });
        //history.push('/micrositio/cotizadorhn')
       openModal();
    }

    const closeModal = () => setData({ ...data, identificacion: '', nombres: '',nombre:'',apellido:'', email: '', celular: '', showModal: false });
    const openModal = () => setData({ ...data, showModal: true });

    const gotoHome = () => history.push('/');

    return (
        <Container>
            <div style={{ maxWidth: "500px" }}>
                <Helmet>
                    <title>Automovil</title>
                </Helmet>
                <br />

                <div>
                    <h3 className="lfh3 txt-center" >¡Cotiza tu seguro Aquí!</h3>
                    <h4 className="lfh4 txt-center" >Con tu póliza de Auto Seguro LAFISE disfruta cada momento sin preocupaciones</h4>
                </div>
                <form action="" className="lfcontainer">

                    <DivRow width='100%' >
                        <DropDownInput label='Tipo de Identificación' dataProvider={tipoDocumentos}
                            value={data.identificacion} onChange={changeHandler}
                            valueSelect={data.tipoId} onChangeSelect={changeHandler}
                            field='identificacion'
                            fieldSelect='tipoId'
                            mask={data.cedMask}
                            //pattern={data.cedPattern}
                            title="Cedula invalida"
                        />
                        <Input type="text" label='Nombres' field='nombre' value={data.nombre} onChange={changeHandler} pattern={letterPattern} />
                            <Input type="text" label='Apellidos' field='apellido' value={data.apellido} onChange={changeHandler} pattern={letterPattern} />

                        <Input label='Correo electrónico' field='email' value={data.email} onChange={handleChange} />
                        <Input label='Celular' pattern='\d\d\d\d-\d\d\d\d' title='Teléfono inválido' type='maskInput' mask='9999-9999' field='celular' placeholder='0000-0000' value={data.celular} onChange={handleChange} />

                        <div style={{marginTop:'15px'}}>
                            <input type="checkbox" name="" id="teminosycondiciones" required />
                            <label htmlFor="teminosycondiciones">Acepto los términos y condiciones</label>
                        </div>
                        <div className="text-right">
                            <a rel='noreferrer' href="https://www.lafise.com/terminos-y-condiciones-de-uso" target='_blank' className="btn-primary">Ver terminos y condiciones</a>
                        </div>
                    </DivRow>
                </form>
                <div className="align-r">
                    <DivRow width='100%'>
                        <button className="control-button-btn btn-next"
                            type="button"
                            onClick={sendNotification}
                            disabled={data.sendDisabled}
                        >Enviar</button>
                    </DivRow>

                </div>


                <Modal
                    isOpen={data.showModal}
                    onRequestClose={closeModal}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                >
                    <div className="dialog-center-content">
                        <div className="fontsize14">
                            <h3 className="h3 txt-primary txt-center">¡Su solicitud ha sido recibida con éxito!</h3>
                            <p>
                                Nos estaremos comunicando con usted lo antes posible.
                            </p>
                            <p>
                                Si desea información adicional puede ponerse en contacto al:
                            </p>
                            <p>
                                <strong className="lfesm">Whatsapp:</strong> (504) 3300-4040 Opción 2 <br />
                                <strong className="lfesm">Telefono:</strong> 2237-4000 Ext.: 10900
                            </p>


                        </div>
                    </div>

                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeModal}>Cerrar</button>
                    </div>
                </Modal>
            </div>
        </Container>
    );
}

export default MicroSitioAutoHN;
